const MEDIA = [
  {
    id: 1,
    title: '韩漫推荐：五部不可错过的恋爱神作',
    desc: '盘点当下最受欢迎的韩漫恋爱佳作，部部都是收藏过万的口碑之作。',
    views: '12.8w',
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20webtoon%20style%20collage%20of%20romantic%20scenes%20with%20soft%20warm%20lighting%20elegant%20character%20designs%20pastel%20coral%20tones%20clean%20cream%20background%20artistic%20composition&width=600&height=360&seq=media-comic-01&orientation=landscape',
  },
  {
    id: 2,
    title: '国漫崛起：从仙侠到科幻的蜕变之路',
    desc: '深入分析国产漫画近年来的品质飞跃与题材多元化发展趋势。',
    views: '9.6w',
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20style%20illustration%20showcasing%20diverse%20genres%20from%20cultivation%20to%20sci-fi%20with%20dynamic%20compositions%20warm%20orange%20and%20gold%20accents%20clean%20cream%20background%20highly%20stylized&width=600&height=360&seq=media-comic-02&orientation=landscape',
  },
  {
    id: 3,
    title: '日漫经典回顾：那些年我们追过的热血番',
    desc: '重温日漫黄金时代的经典作品，每一部都是青春的回忆。',
    views: '8.3w',
    image: 'https://readdy.ai/api/search-image?query=A%20Japanese%20manga%20style%20retrospective%20illustration%20with%20classic%20action%20scenes%20nostalgic%20warm%20tone%20vintage%20comic%20panel%20aesthetic%20clean%20cream%20background%20highly%20stylized%20artistic&width=600&height=360&seq=media-comic-03&orientation=landscape',
  },
  {
    id: 4,
    title: '下拉式阅读为什么比翻页更舒服？',
    desc: '从阅读习惯和交互设计角度，解析99漫画下拉式阅读的优势所在。',
    views: '7.1w',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20displaying%20vertical%20scrolling%20webtoon%20content%20with%20clean%20UI%20design%20warm%20ambient%20lighting%20minimalist%20setup%20cream%20background%20clean%20composition&width=600&height=360&seq=media-comic-04&orientation=landscape',
  },
  {
    id: 5,
    title: '新手入门：99漫画追更收藏完全指南',
    desc: '手把手教你如何使用99漫画的全部功能，快速成为资深漫迷。',
    views: '6.5w',
    image: 'https://readdy.ai/api/search-image?query=A%20friendly%20illustrated%20guide%20showing%20comic%20reading%20app%20features%20with%20warm%20coral%20accents%20clean%20flat%20design%20user%20interface%20elements%20cream%20background%20highly%20stylized%20artistic&width=600&height=360&seq=media-comic-05&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">精彩看点</h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            漫画推荐、阅读指南与平台动态精彩内容，帮你发现更多好漫画
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {MEDIA.slice(0, 3).map((item) => (
            <a
              key={item.id}
              href="#media"
              className="group bg-background-50 border border-background-200/60 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="aspect-video overflow-hidden bg-background-200 relative">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                  loading="lazy"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/80 backdrop-blur-sm flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1.5 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mb-2 line-clamp-2">{item.desc}</p>
                <span className="text-xs text-foreground-400">
                  <i className="ri-eye-line mr-1"></i>
                  {item.views} 次浏览
                </span>
              </div>
            </a>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5 mt-4">
          {MEDIA.slice(3).map((item) => (
            <a
              key={item.id}
              href="#media"
              className="group flex flex-col sm:flex-row bg-background-50 border border-background-200/60 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="sm:w-48 flex-shrink-0 aspect-video sm:aspect-auto overflow-hidden bg-background-200 relative">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                  loading="lazy"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-9 h-9 rounded-full bg-background-50/80 backdrop-blur-sm flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                    <i className="ri-play-fill text-base ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="flex-1 p-4 flex flex-col justify-center">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mb-2">{item.desc}</p>
                <span className="text-xs text-foreground-400">
                  <i className="ri-eye-line mr-1"></i>
                  {item.views} 次浏览
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}